module.exports = __webpack_public_path__ + "img/slider2.d7de1f40.png";